import moment from "moment";

export const numEn = (num) => {
  let result = new Intl.NumberFormat("en", {
    maximumSignificantDigits: 3,
  }).format(num);
  return result;
};

export class DateHelper {
  static GetFullDayString = (date) => {
    return moment(date).format("dddd");
  };
  static GetHour = (date) => {
    return moment(date).format("HH:mm");
  };
  static numberizeHours = (hour) => {
    return parseInt(hour.replace(":", ""));
  };

  static isTimeInRange = (time, startlimit, endlimit) => {
    const isInRange =
      moment(`01/01/2022 ${time}`).isBetween(
        `01/01/2022 ${startlimit}`,
        `01/01/2022 ${endlimit}`
      ) ||
      moment(`01/01/2022 ${time}`).isSame(`01/01/2022 ${startlimit}`) ||
      moment(`01/01/2022 ${time}`).isSame(`01/01/2022 ${endlimit}`);
    return isInRange;
  };

  static GetFullMonthString = (date) => {
    return moment(date).format("MMMM");
  };

  static Get3LettersDay = (date) => {
    return moment(date).format("DDD");
  };

  static GetDayAsNumber = (date) => {
    return moment(date).format("DD");
  };

  static GetMonthAsNumber = (date) => {
    return moment(date).format("MM");
  };

  static Get3LettersMonth = (date) => {
    return moment(date).format("MMM");
  };

  static AddDays = (date, days) => {
    return moment(date).add(days, "day");
  };

  static AddMonths = (date, months) => {
    return moment(date).add(months, "month");
  };

  static DDD_DD_MMM_YYYY = (date) => {
    return moment(date).format("ddd DD MMM, YYYY");
  };

static TimeClashChecker = (start1, end1, start2, end2) => {
  const s1 = moment(start1).startOf("day");
  const e1 = moment(end1).startOf("day");
  const s2 = moment(start2).startOf("day");
  const e2 = moment(end2).startOf("day");

  // If new package starts exactly on the end date of old one → allow
  if (s2.isSame(e1)) {
    return false;
  }

  let foundClash =
    (s1.isSameOrAfter(s2) && s1.isSameOrBefore(e2)) ||
    (e1.isSameOrAfter(s2) && e1.isSameOrBefore(e2)) ||
    (s1.isSameOrBefore(s2) && e1.isSameOrAfter(e2));

  return foundClash;
};


  static FormatFullMonth_WeekRange = (date) => {
    let startDate = date.clone();
    let endDate = startDate.add(6, "day");

    return `${date.format("MMMM DD")}-${
      this.GetMonthAsNumber(date) === this.GetMonthAsNumber(endDate)
        ? ""
        : this.GetFullMonthString(endDate)
    }${this.GetDayAsNumber(endDate)}`;
  };
}

export const CapitalizeFirstLetter = (str) => {
  if (!str.includes(" ")) return str.charAt(0).toUpperCase() + str.slice(1);
  else {
    let [firstWord, secondWord] = str.split(" ");
    firstWord = firstWord.charAt(0).toUpperCase() + firstWord.slice(1);
    secondWord = secondWord.charAt(0).toUpperCase() + secondWord.slice(1);
    return `${firstWord} ${secondWord}`;
  }
};

// Function to convert base64 to Blob
export const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

// Function to download Excel file for failed records
export const downloadFailedRecordsExcel = (excelData, fileName) => {
  const blobData = b64toBlob(excelData, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
  const url = window.URL.createObjectURL(blobData);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}.xlsx`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
